import { AccessComponentEnum, AccessLevelEnum } from 'graphql-common';
import { APP_URLS } from 'constants/urls';
import { NavItemTypeEnum } from '@lib/components/Menu/Menu';
import Icons from '@lib/components/Icons/Icons';
import { NavItemArgs } from './types';

export default function getHomeNavItem(args: NavItemArgs) {
  const { t, pathname, getUserAccessByComponent } = args;
  const isHomePageAvailable =
    getUserAccessByComponent(AccessComponentEnum.HomePageManagement) !==
    AccessLevelEnum.LimitedRead;
  return {
    id: 'home',
    title: t('home-page'),
    leftIcon: Icons.home,
    to: APP_URLS.dashboard.home.getPathWithQuery(),
    type: NavItemTypeEnum.Primary,
    end: true,
    predictorFnVisible: () => isHomePageAvailable,
    predictorFnActive: () => {
      return (
        pathname === APP_URLS.dashboard.home.path ||
        pathname === APP_URLS.dashboard.homeEdit.path ||
        pathname === APP_URLS.dashboard.homeWidgets.path ||
        pathname === APP_URLS.dashboard.homeWidgetsCreate.path
      );
    },
  };
}
